import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AdminDashboard from './components/Admin';
import ContactMessages from './components/Contact';
import SupportMessages from './components/Support';
import Discounts from './components/Discounts';
import Login from './components/Home';
import Chats from './components/Chats';
import Users from './components/Users';
import SellerVerify from './components/SellersVerify';
import Indexing from './components/Indexing';
import BlogEditor from './components/BlogEditor';
import Blogs from './components/Blogs';
import ExcelUploader from './components/Calculator';
import SmsComponent from './components/Sms';
import RestrictedFields from './components/RestrictedFields';
import ServicePages from './components/ServicePages';
import EncryptedFields from './components/EncryptFields';
import PostsApproval from './components/PostsApproval';
import CareerJobUpdate from './components/CareerJobUpdate';
import AdminBrokerUploader from './components/UploadClaimingProfiles';
import ClaimingProfiles from './components/ClaimingProfiles';
import UploadImages from './components/UploadImages';
import Feedbacks from './components/Feedbacks';
import FeatureToggles from './components/FeatureToggles';
import Auth from './components/Auth';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes - No Auth Required */}
        <Route exact path="/" element={<Login />} />
        <Route path="/home" element={<Login />} />
        {/* Protected Routes - Auth Required */}
        <Route
          path="/admin"
          element={
            <Auth>
              <AdminDashboard />
            </Auth>
          }
        />
        <Route
          path="/discounts"
          element={
            <Auth>
              <Discounts />
            </Auth>
          }
        />
        <Route
          path="/contact-message"
          element={
            <Auth>
              <ContactMessages />
            </Auth>
          }
        />
        <Route
          path="/support-message"
          element={
            <Auth>
              <SupportMessages />
            </Auth>
          }
        />
        <Route
          path="/chats-inspect"
          element={
            <Auth>
              <Chats />
            </Auth>
          }
        />
        <Route
          path="/users-inspect"
          element={
            <Auth>
              <Users />
            </Auth>
          }
        />
        <Route
          path="/sellers-verify"
          element={
            <Auth>
              <SellerVerify />
            </Auth>
          }
        />
        <Route
          path="/indexing"
          element={
            <Auth>
              <Indexing />
            </Auth>
          }
        />
        <Route
          path="/blogs/:blogUrl"
          element={
            <Auth>
              <BlogEditor />
            </Auth>
          }
        />
        <Route
          path="/blogs"
          element={
            <Auth>
              <Blogs />
            </Auth>
          }
        />
        <Route
          path="/upload-tool-data"
          element={
            <Auth>
              <ExcelUploader />
            </Auth>
          }
        />
        <Route
          path="/sms-sender"
          element={
            <Auth>
              <SmsComponent />
            </Auth>
          }
        />
        <Route
          path="/restrict-fields"
          element={
            <Auth>
              <RestrictedFields />
            </Auth>
          }
        />
        <Route
          path="/service-pages"
          element={
            <Auth>
              <ServicePages />
            </Auth>
          }
        />
        <Route
          path="/encrypted-fields"
          element={
            <Auth>
              <EncryptedFields />
            </Auth>
          }
        />
        <Route
          path="/posts-approval"
          element={
            <Auth>
              <PostsApproval />
            </Auth>
          }
        />
        <Route
          path="/career-job-update"
          element={
            <Auth>
              <CareerJobUpdate />
            </Auth>
          }
        />
        <Route
          path="/upload-claiming-profiles"
          element={
            <Auth>
              <AdminBrokerUploader />
            </Auth>
          }
        />
        <Route
          path="/brokers/:id?"
          element={
            <Auth>
              <ClaimingProfiles />
            </Auth>
          }
        />
        <Route
          path="/upload-images"
          element={
            <Auth>
              <UploadImages />
            </Auth>
          }
        />
        <Route
          path="/feedbacks"
          element={
            <Auth>
              <Feedbacks />
            </Auth>
          }
        />
        <Route
          path="/feature-toggles"
          element={
            <Auth>
              <FeatureToggles />
            </Auth>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
